// extracted by mini-css-extract-plugin
module.exports = {"panel":"Panel_panel__1We_P","title":"Panel_title__1yBCs","content":"Panel_content__1UmPW"};